<gallery
  id="imageGallery"
  [thumb]="images.length > 1 ? true : false"
  (itemClick)="openInFullScreen($event)"
  #imageGallery
  loadingMode="indeterminate"
  class="{{ category }}"
  *ngIf="images"

  [counter]="false"
  [items]="images"
  [thumbHeight]="102"
  [thumbWidth]="112"
  [loop]="false">
</gallery>
